import {ErrorFlow} from 'olympe';

/**
 * @param {BrickContext} $
 * @param {*} lambda
 * @param {!Array<*>} inputsValues input values except for control flow, in order of the function signature.
 * @param {number} customErrorCode
 * @return {Promise<*|!Array<*>>}
 */
export function executeLambda($, lambda, inputsValues, customErrorCode = -1) {
    const inputs = lambda.getInputs();
    // get first input that should be a control flow
    const controlFlowIn = inputs.shift();
    // remove control flows and error flows (they have to be first two)
    const [controlFlowOut, errorFlowOut, ...outputs] = lambda.getOutputs();

    if (inputs.length !== inputsValues.length) {
        const errorMsg = `Inputs provided to the lambda: ${inputsValues.length}, but expected ${inputs.length} from function signature
        , values: ${JSON.stringify(inputsValues)}`;
        console.error(errorMsg);
        return Promise.reject(errorMsg);
    }
    const runner = $.runner(lambda);
    for (const [idx, inputSignature] of inputs.entries()) {
        runner.set(inputSignature, inputsValues[idx]);
    }
    runner.trigger(controlFlowIn);
    return Promise.race([
        runner.waitFor(controlFlowOut),
        runner.waitFor(errorFlowOut),
    ]).then((outputFlow) => {
        if (outputFlow instanceof ErrorFlow) {
            const customErrorFlow = customErrorCode === -1 ? outputFlow : ErrorFlow.create(outputFlow.getMessage(), customErrorCode);
            console.error(JSON.stringify(customErrorFlow));
            console.error('Error output flow message: ', outputFlow.getMessage());
            return customErrorFlow;
        } else {
            if (outputs.length === 1) {
                return runner.get(outputs[0]);
            }
            const resultArray = [];
            if (outputs.length > 1) {
                for (const outputName of outputs) {
                    resultArray.push(runner.get(outputName));
                }
            }
            return resultArray;
        }
    })
        .catch((reason) => {
            const customErrorFlow = ErrorFlow.create(reason, customErrorCode);
            console.error(JSON.stringify(customErrorFlow));
            console.error('Promise race has failed:  ', reason);
            return customErrorFlow;
        })
        .finally(() => runner.destroy());
}
